<template>
  <IFrameWrapper v-if="iframeSrc" :src="iframeSrc" />
</template>

<script lang="ts" setup>
import { DEEP_ADMIN_UI_URLS } from '@/plugins/hybrid/hybrid.routes'
import { useHybridPage } from '@/plugins/hybrid/hybrid.use'
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import IFrameWrapper from '@/components/IFrameWrapper.vue'

const { permissions } = useAuthorizationContext()
const { selectedOrganization } = useAccountMembershipsContext()

useHybridPage()

definePage({
  props: true,
  meta: {
    isHybridAdminRoute: true,
    breadcrumbLabelKey: 'navigation.organization.billing.subscription',
  },
})

const props = defineProps({
  organizationId: {
    type: String,
    required: true,
  },
})

const route = useRoute()
const iframePath = computed(() => route.query.iframe_path as string)

usePageAccess(
  computed(
    () =>
      !permissions.canManageSubscription ||
      selectedOrganization.value?.resource.verification?.state !== 'verified',
  ),
)

const iframeSrc = computed(() => {
  if (iframePath.value) {
    const baseUrl = window.location.origin
    return `${baseUrl}${iframePath.value}${route.hash || ''}`
  }
  if (!props.organizationId) return null

  return DEEP_ADMIN_UI_URLS.ORGANIZATION_SUBSCRIPTION.replace(
    ':organization',
    props.organizationId,
  )
})
</script>
